import { Component, OnInit } from '@angular/core';
import { AuthService } from '@authentication/auth.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  isAuthenticated: boolean;

  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.authService.getUser().then(user => {
      this.isAuthenticated = user != null;
      console.log('¡Bienvenido a PAD Aeroplantas!');
    });
  }
}
